<template>
  <div v-if="showPopup" class="popup" @click.self="closePopup">
    <div :style="arrowPos" class="popup-arrow">
      <img :src="getArrowImage" alt="" />
    </div>
    <div class="popup-install">
      <div class="popup-install__logo">
        <img :src="getLogoImage" alt="Left To Survive" height="174" loading="lazy" width="300" />
      </div>
      <div class="popup-install__text">
        <div class="popup-install__header">{{ $t("popup.install.header") }}</div>
        <p>{{ $t("popup.install.text") }}</p>
        <ol>
          <li>{{ $t("popup.install.steps.step1") }}</li>
          <li>{{ $t("popup.install.steps.step2") }}</li>
        </ol>
      </div>
      <PromoButton @click="closePopup"> {{ $t("popup.install.close") }}</PromoButton>
    </div>
  </div>
</template>
<script>
import PromoButton from "../../promo-button/vue/PromoButton.vue";
import { getDownloadArrowPosition } from "@godweb/frontend-base/src/libs/tools/get-download-arrow-position";

export default {
  name: "PopupInstall",
  components: { PromoButton },
  props: {
    showPopup: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    arrowPos() {
      return {
        [getDownloadArrowPosition().position]: getDownloadArrowPosition().value + "px",
      };
    },
    getArrowImage() {
      return require("@static_promo_pages/common/components/popups/images/arrow.svg");
    },
    getLogoImage() {
      console.info("getDownloadArrowPosition", getDownloadArrowPosition());
      return require("@static_promo_pages/common/static/images/logo.webp");
    },
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/popup-install";
</style>
